import { render, staticRenderFns } from "./carbonUptake.vue?vue&type=template&id=34beb089&scoped=true"
import script from "./carbonUptake.vue?vue&type=script&lang=js"
export * from "./carbonUptake.vue?vue&type=script&lang=js"
import style0 from "./carbonUptake.vue?vue&type=style&index=0&id=34beb089&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34beb089",
  null
  
)

export default component.exports